import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import Stage, { Props } from '../_components/Stage';
import HIDContainer from '../../HID/_containers/HIDContainer';
import HIDEvents from '../_events/StageHIDEvents';
import * as ModuleListActions from '../../ModuleList/_actions/ModuleListActions';
import * as LayerListActions from '../../LayerList/_actions/LayerListActions';
import { ModuleOnMultipleValueUpdate } from '../../Module/_actions/ModuleActions';
import { OnChangeDPI, OnChangeOffsetX, OnChangeOffsetY } from '../../Document/_actions/DocumentActions';

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	selectModule: (moduleId:string) => dispatch(ModuleListActions.OnModuleSelect(moduleId)),
	selectLayer: (layerId:string) => dispatch(LayerListActions.OnLayerSelect(layerId)),
	setDPI: (dpi:number) => dispatch(OnChangeDPI(dpi)),
	setDocumentOffsetX: (x:number) => dispatch(OnChangeOffsetX(x)),
	setDocumentOffsetY: (y:number) => dispatch(OnChangeOffsetY(y)),
	moduleUpdater: (moduleId:string, updates:{key:string, value:any}[]) => dispatch(ModuleOnMultipleValueUpdate(moduleId, updates)),
});

const mapStateToProps = (store:Store, props:Props) => {
	let layerIds = store.getIn(['create', 'layerList', 'layersOrder'])
	let previewFabricWidth = store.getIn(['create','tools','previewFabric','width'])
	let previewFabricHeight = store.getIn(['create','tools','previewFabric','height'])
	
	return {
		designId: store.getIn(['create', 'document', 'designId']),

		viewerWidth: store.getIn(['create','viewer','width']),
		viewerHeight: store.getIn(['create','viewer','height']),
		documentOffsetX: store.getIn(['create', 'document', 'offsetX']),
		documentOffsetY: store.getIn(['create', 'document', 'offsetY']),
		documentWidth: store.getIn(['create', 'document', 'width']),
		documentHeight: store.getIn(['create', 'document', 'height']),
		documentDPI: store.getIn(['create', 'document', 'dpi']),
		documentQuality: store.getIn(['create', 'document', 'quality']),
		documentUnits: store.getIn(['create', 'document', 'units']),
		attachedModule: store.getIn(['create','document','attachedModule']),
		layers: store.getIn(['create', 'layerList', 'layers'])
			.filter((value:any, key:any) => layerIds.includes(key))
			.sortBy((value:any, key:any) => key, (a:any, b:any) => {
				a = layerIds.valueSeq().findIndex((key:any) => key == a);
				b = layerIds.valueSeq().findIndex((key:any) => key == b);
				return (a < b) ? -1 : (a > b) ? 1 : 0;
			}),
		modules: store.getIn(['create', 'moduleList', 'modules']),
		selectedModuleId: store.getIn(['create', 'moduleList', 'selectedModuleId']),
		gridEnabled: store.getIn(['create','tools','grid','enabled']),
		overlayEnabled: store.getIn(['create','tools','overlay','enabled']),

		previewFabricEnabled: store.getIn(['create','tools','previewFabric','enabled']) && previewFabricWidth && previewFabricHeight,
		previewFabricWidth: previewFabricWidth,
		previewFabricHeight: previewFabricHeight,

		repeatMode: store.getIn(['create','tools','repeatMode','type']),

		rulersEnabled: store.getIn(['create','tools','rulers','enabled']),
		spaceDown: store.getIn(['create', 'hid', 'spaceDown'])
	}
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(HIDContainer(Stage, HIDEvents));